import React from 'react';

import SkeletonDivDefault from '@components/skeleton/SkeletonDivDefault';

const ContactPersonCardSkeleton = () => (
  <>
    <div className='flex justify-center'>
      <div className='w-3/5'>
        <SkeletonDivDefault />
      </div>
    </div>

    <div className='mt-8 flex justify-end'>
      <div className='w-3/5'>
        <SkeletonDivDefault />
      </div>
    </div>
    <div className='mt-2 flex justify-end'>
      <div className='w-3/5'>
        <SkeletonDivDefault />
      </div>
    </div>
    <div className='mt-10'>
      <SkeletonDivDefault />
    </div>
    <div className='mt-8'>
      <SkeletonDivDefault />
    </div>
  </>
);

export default ContactPersonCardSkeleton;
